import { defineComponent as _defineComponent } from 'vue'
import { LocalizacaoLivro } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'TabelaLocalizacao',
  props: {
    items: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})